import { render, staticRenderFns } from "./materialCard.vue?vue&type=template&id=955432a2&"
import script from "./materialCard.vue?vue&type=script&lang=js&"
export * from "./materialCard.vue?vue&type=script&lang=js&"
import style0 from "./materialCard.vue?vue&type=style&index=0&id=955432a2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports